import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const SubscriptService = {
  /**
   * @description get subscription status
   *
   * @returns {object}
   */
  getSubscription(token) {
    const apiURL = `${API_HOST}/${API_VERSION}/subscription`
    // const token = window.localStorage.getItem(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY)
    return Axios.request({
      method: 'GET',
      url: apiURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description get subscription plans
   *
   * @returns {object}
   */
  getSubscriptionPlan(params) {
    const apiURL = `${API_HOST}/${API_VERSION}/subscription/plans`
    return Axios.request({
      method: 'GET',
      url: apiURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  postSubscription(params) {
    const apiURL = `${API_HOST}/${API_VERSION}/payment/ecpay`
    const token = window.localStorage.getItem(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY)
    let XHR = new XMLHttpRequest()
    var urlEncodedData = ''
    var urlEncodedDataPairs = []

    for (let name in params) {
      urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(params[name]))
    }
    urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+')
    XHR.addEventListener('load', function(event) {
      console.log('done')
    })
    XHR.addEventListener('error', function(event) {
      console.log('error')
    })

    XHR.open('POST', apiURL)
    XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    XHR.setRequestHeader('Authorization', 'Bearer ' + token)
    XHR.send(urlEncodedData)

    // return Axios
    //   .request({
    //     method: 'POST',
    //     url: apiURL,
    //     headers: {
    //       'Authorization': 'Bearer ' + token
    //     },
    //     params
    //   })
    //   .then(res => {
    //     if (res && res.data) {
    //       return res.data
    //     }
    //     return { data: [] }
    //   })
    //   .catch(err => {
    //     console.error(err)
    //     return null
    //   })
  }
}
export default SubscriptService
